
const ROOT = '/role-management'

const roleManagementPaths = {
  root: ROOT,
  addRole: `${ROOT}/add-role`,
};

export default roleManagementPaths;
